
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.297 0c.791 0 1.448.657 1.448 1.465v3.436c0 .808-.64 1.465-1.448 1.465h-1.01v.775c.134-.05.286-.067.437-.067.489 0 .927.252 1.162.673.186-.1.388-.151.607-.151.488 0 .926.252 1.162.673a1.337 1.337 0 011.954 1.179l-.017 2.998a3.53 3.53 0 01-1.045 2.51A3.53 3.53 0 0111.037 16H9.523a3.956 3.956 0 01-3.065-1.448l-2.425-2.93a1.367 1.367 0 01-.304-1.062c.068-.37.27-.707.59-.926a1.374 1.374 0 011.718.168l.556.556V6.349H2.448A1.463 1.463 0 011 4.884V1.465C1 .657 1.64 0 2.448 0zM7.956 4.21a.446.446 0 00-.438.438v6.3a.64.64 0 01-.404.606.67.67 0 01-.725-.135l-.976-.977a.46.46 0 00-.32-.135.454.454 0 00-.253.085.413.413 0 00-.185.303.444.444 0 00.1.353l2.426 2.93a3.072 3.072 0 002.375 1.113h1.516c.69 0 1.364-.27 1.903-.758a2.61 2.61 0 00.774-1.87V9.465a.446.446 0 00-.437-.438.446.446 0 00-.438.438v.59a.453.453 0 01-.455.454.453.453 0 01-.455-.454V8.926c0-.235-.202-.438-.438-.438s-.438.203-.438.438v.59a.453.453 0 11-.91 0V8.387a.446.446 0 00-.437-.438.446.446 0 00-.438.438v.59a.453.453 0 01-.455.455.453.453 0 01-.454-.455V4.648a.422.422 0 00-.135-.303.422.422 0 00-.303-.134zm2.324-3.2H2.448a.45.45 0 00-.437.455v3.42c0 .252.185.454.437.454v.017h4.16v-.674c0-.74.59-1.347 1.33-1.347a1.325 1.325 0 011.331 1.33v.674h1.011a.45.45 0 00.438-.455V1.465a.439.439 0 00-.438-.454zM5.362 2.19c.169-.186.489-.186.674-.017a.452.452 0 01.017.64L4.789 4.16a.424.424 0 01-.336.152.424.424 0 01-.337-.152l-.657-.707a.438.438 0 01.017-.64.438.438 0 01.64.016l.32.354z"}})])
          )
        }
      }
    